import { isDefined } from './helpers';

export function initSliderAboutImage()
{
    const sliderWrapper = document.querySelectorAll('.is-custom-slider');

    if(!isDefined(sliderWrapper)) return;

    sliderWrapper.forEach(function(element) {

        let buttonNext = (element.querySelector('.section-view-image-slider-button-next') || null);
        let buttonPrev = (element.querySelector('.section-view-image-slider-button-prev') || null);
        let zindex = 2;

        if(!isDefined(buttonNext) || !isDefined(buttonPrev)) return;
        buttonPrev.addEventListener('click', function(e) {
            e.preventDefault();
            runSlider('prev')
        })
        
        buttonNext.addEventListener('click', function(e) {
            e.preventDefault();
            runSlider('next')
        })

        let currentActive = element.querySelector('.slider-item.active');
        let currentActiveNext;
        let currentActiveNextIndex;
        let length = element.querySelectorAll('.slider-item').length;

        function runSlider(direction)
        {

            if(direction == "next")
            {
                currentActiveNext = currentActive.nextElementSibling;
                if(currentActiveNext == null)
                {
                    return;
                }

                currentActiveNext.querySelector('.slider-item-content').classList.add('mask_right');
                currentActiveNext.querySelector('.slider-item-content').classList.remove('mask_left');
            }

            if(direction == "prev")
            {
                currentActiveNext = currentActive.previousElementSibling;
                if(currentActiveNext == null)
                {
                    return;
                }

                currentActiveNext.querySelector('.slider-item-content').classList.remove('mask_right');
                currentActiveNext.querySelector('.slider-item-content').classList.add('mask_left');
            }

            currentActiveNext.classList.add('active');
            currentActiveNext.classList.remove('show');
            currentActiveNext.style.setProperty("z-index", zindex);

            currentActive.classList.remove('active')

            currentActiveNext.querySelector('img').classList.add('no_transition');
            currentActiveNext.querySelector('.slider-item-content').classList.add('no_transition');
            currentActiveNext.querySelector('.t_container').classList.add('no_transition');

            currentActive = currentActiveNext;
            setTimeout(function(){
                currentActiveNext.querySelector('img').classList.remove('no_transition');
                currentActiveNext.querySelector('.slider-item-content').classList.remove('no_transition');
                currentActiveNext.querySelector('.t_container').classList.remove('no_transition');
                currentActiveNext.classList.add('show');
            },20);

            currentActiveNextIndex = (Array.from(element.querySelectorAll('.slider-item')).indexOf(currentActive) + 1);

            if(currentActiveNextIndex == length)
            {
                buttonNext.classList.add('disabled');
                buttonPrev.classList.remove('disabled');
            }

            if(currentActiveNextIndex == 1)
            {
                buttonPrev.classList.add('disabled');
                buttonNext.classList.remove('disabled');
            }

            zindex++;
        }
    });
}